/**
 * /dashboard/performance/cycles — HR-admin cycle administration.
 *
 * Reuses the ReviewsTab body — it shows the review cycles list + the
 * "New cycle" CTA (gated on isPerfAdmin client-side; the backend
 * RBAC-enforces the mutation too). 2026-10: an index route so the cycle
 * pages live under /performance/cycles (Run surface) — New cycle and the
 * cycle hub no longer flip the sidebar to the Inbox surface.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/cycles/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewsTab } from "@/components/performance/reviews-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/cycles/",
)({
  component: PerformanceCyclesRoute,
});

function PerformanceCyclesRoute() {
  return (
    <PerformanceModuleShell
      title="Performance"
      description="HR runs review cycles from here: create one, move it through its stages and close it."
    >
      <PerformanceFeatureGate>
        <ReviewsTab admin />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
